export type DataItem = {
  userId: string;
  timestamp: string;
};

export type BaseUserMessage = {
  role: 'user' | 'system' | 'assistant';
  content: string;
};

export type UserMessage = DataItem & BaseUserMessage;

export enum InterviewStatus {
  INTERVIEW_NOT_STARTED = 'INTERVIEW_NOT_STARTED',
  INTERVIEW_STARTED = 'INTERVIEW_STARTED',
  LAST_QUESTION_STARTED = 'LAST_QUESTION_STARTED',
  LAST_QUESTION_ANSWERED = 'LAST_QUESTION_ANSWERED',
  INTERVIEW_COMPLETED = 'INTERVIEW_COMPLETED',
  INTERVIEW_EXPIRED = 'INTERVIEW_EXPIRED',
}

export const MessageBlockingInterviewStatuses = [
  InterviewStatus.INTERVIEW_EXPIRED,
  InterviewStatus.INTERVIEW_COMPLETED,
];

export type BaseUserInfo = {
  threadId?: string;
  rating?: number;
  status?: InterviewStatus;
  statusTimestamp?: number;
};

export type UserInfo = DataItem & BaseUserInfo;

export type BaseProfile = {
  complete?: boolean;
  prefaceRead?: boolean;
  linkedInUrl?: string;
  city?: string;
};

export type Profile = DataItem & BaseProfile;

export type ProfileForAdmin = Profile &
  UserInfo & {
    resumeDownloadUrl?: string;
    audioSampleDownloadUrl?: string;
  };

export type User = {
  date_created: number;
  preferred_username: string;
  username: string;
  given_name: string;
  family_name: string;
  email: string;
  phone_number: string;
  sub: string;
};

export type UserListInfo = {
  cursor?: string;
  users: User[];
};
